// extracted by mini-css-extract-plugin
export var closeButton = "_95-0";